var _path, _path2, _path3, _path4, _path5, _path6, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNews = function SvgNews(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 240 172"
  }, props), /*#__PURE__*/React.createElement("linearGradient", {
    id: "news_svg__a",
    x1: 86.304,
    x2: 160.991,
    y1: 48.754,
    y2: 123.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41beb6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00a69c"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#news_svg__a)",
    d: "M120.244 124.757c-23.196 0-42.066-18.869-42.066-42.063 0-23.196 18.87-42.067 42.066-42.067 23.193 0 42.062 18.871 42.062 42.067 0 23.194-18.868 42.063-42.062 42.063m0-80.538c-21.214 0-38.474 17.258-38.474 38.476 0 21.212 17.26 38.47 38.474 38.47s38.469-17.258 38.469-38.47c0-21.218-17.256-38.476-38.469-38.476"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "news_svg__b",
    x1: 86.305,
    x2: 160.994,
    y1: 48.754,
    y2: 123.443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41beb6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00a69c"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#news_svg__b)",
    d: "M120.244 124.757c-15.319 0-27.779-18.869-27.779-42.067 0-23.191 12.46-42.063 27.779-42.063 15.315 0 27.779 18.871 27.779 42.063 0 23.198-12.463 42.067-27.779 42.067m0-80.538c-13.336 0-24.187 17.258-24.187 38.471 0 21.214 10.85 38.475 24.187 38.475 13.336 0 24.187-17.261 24.187-38.475 0-21.213-10.851-38.471-24.187-38.471"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "news_svg__c",
    x1: 86.305,
    x2: 160.996,
    y1: 48.752,
    y2: 123.443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41beb6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00a69c"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#news_svg__c)",
    d: "M120.244 124.757c-8.779 0-11.097-27.519-11.097-42.067s2.318-42.063 11.097-42.063 11.098 27.514 11.098 42.063-2.319 42.067-11.098 42.067m0-80.538c-2.548 0-7.505 13.58-7.505 38.471 0 24.896 4.957 38.475 7.505 38.475s7.504-13.579 7.504-38.475c0-24.891-4.956-38.471-7.504-38.471"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "news_svg__d",
    x1: 86.304,
    x2: 160.992,
    y1: 48.755,
    y2: 123.443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41beb6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00a69c"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#news_svg__d)",
    d: "M120.239 110.473c-23.191 0-42.062-12.462-42.062-27.778 0-15.319 18.87-27.78 42.062-27.78 23.198 0 42.066 12.461 42.066 27.78.001 15.316-18.867 27.778-42.066 27.778m0-51.965c-21.209 0-38.469 10.851-38.469 24.187 0 13.338 17.26 24.185 38.469 24.185 21.216 0 38.474-10.847 38.474-24.185s-17.258-24.187-38.474-24.187"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "news_svg__e",
    x1: 86.303,
    x2: 160.988,
    y1: 48.756,
    y2: 123.442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#41beb6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00a69c"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#news_svg__e)",
    d: "M120.239 93.793c-14.546 0-42.062-2.318-42.062-11.099 0-8.778 27.516-11.097 42.062-11.097 14.552 0 42.066 2.318 42.066 11.097.001 8.781-27.514 11.099-42.066 11.099m0-18.605c-24.89 0-38.469 4.958-38.469 7.506s13.58 7.505 38.469 7.505c24.896 0 38.474-4.957 38.474-7.505s-13.578-7.506-38.474-7.506"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#BBBDBF",
    d: "M122.039 167.839c-45.658 0-82.802-37.144-82.802-82.802 0-45.657 37.144-82.802 82.802-82.802 45.657 0 82.8 37.145 82.8 82.802 0 15.152-4.126 29.97-11.938 42.858l-.771-.466c7.729-12.748 11.812-27.408 11.812-42.393 0-45.162-36.742-81.905-81.903-81.905S40.135 39.874 40.135 85.036s36.743 81.902 81.904 81.902c18.025 0 35.121-5.741 49.441-16.604l.545.714c-14.481 10.983-31.765 16.791-49.986 16.791"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#BBBDBF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m53.364 17.399 39.129 39.129-.634.634-39.13-39.129z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.547 19.561a5.863 5.863 0 0 1-5.856-5.858 5.8 5.8 0 0 1 1.713-4.137 5.8 5.8 0 0 1 4.134-1.717c3.237 0 5.864 2.627 5.864 5.854a5.82 5.82 0 0 1-1.713 4.142 5.82 5.82 0 0 1-4.142 1.716m-.001-10.813c-1.328 0-2.572.517-3.507 1.452s-1.449 2.179-1.449 3.502a4.965 4.965 0 0 0 4.958 4.96 4.94 4.94 0 0 0 3.508-1.45 4.93 4.93 0 0 0 1.45-3.51 4.964 4.964 0 0 0-4.96-4.954"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#BBBDBF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m183.092 163.299-22.77-22.767 22.77-22.767 22.764 22.767zm-21.499-22.767 21.499 21.495 21.494-21.495-21.494-21.497z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.745 140.006h58.853v.897h-58.853z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.838 110.908h.898v58.855h-.898z"
  }))));
};
export default SvgNews;